import { cn } from '@/lib/utils.ts'

export type AnalyticsLegendStoryType = Exclude<StoryType, 'Release'>

export type BadgeVariantType = AnalyticsLegendStoryType | 'Accepted Points' | 'Running Velocity' | 'Running Volatility'

type ChartBadgeProps = {
  variant: BadgeVariantType
  value: string
}

export const ChartBadge = ({ variant, value }: ChartBadgeProps) => {
  const variantStyles: Record<BadgeVariantType, string> = {
    Feature: 'bg-tb-navy-100 text-tb-grey-000',
    Design: 'bg-tb-blue-200 text-tb-blue-900',
    Chore: 'bg-tb-green-100 text-tb-green-900',
    Bug: 'bg-alarm-red-100 text-alarm-red-900',
    'Accepted Points': 'bg-tb-navy-100 text-tb-grey-000',
    'Running Velocity': 'bg-alarm-red-100 text-alarm-red-900',
    'Running Volatility': 'bg-alarm-red-100 text-alarm-red-900',
  }

  return (
    <div className={cn('rounded-xs px-1 font-EN-KR-caption-regular shrink-0', variantStyles[variant])}>{value}</div>
  )
}
